import { render } from "./news-list-skeleton.vue?vue&type=template&id=20561c86&scoped=true"
import script from "./news-list-skeleton.vue?vue&type=script&lang=js"
export * from "./news-list-skeleton.vue?vue&type=script&lang=js"

import "./news-list-skeleton.vue?vue&type=style&index=0&id=20561c86&scoped=true&lang=less"

import exportComponent from "G:\\PRO\\shview\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20561c86"]])

export default __exports__